import { vservice } from '@niknevis/vue-modules'
import { ContentService } from '@/modules/content/services/content.service'
import { RemoteData } from '@/modules/shared/helpers/http/remote-data'
import { Data } from '@/modules/shared/models/data'
import { ContentConvertDocxToHtmlRequestModel } from '@/modules/content/models/content-requests.model'

@vservice()
export class ContentConvertDocxToHtmlUseCase {
  constructor(
    private readonly service: ContentService
  ) {
  }

  private remoteData = RemoteData.notAsked<Data<ContentConvertDocxToHtmlRequestModel>>()

  get isLoading() {
    return this.remoteData.isInProgress()
  }

  //! Experimental
  get getResponse() {
    return this.remoteData.fold(
      () => null,
      value => value?.data || null,
      value => value.data,
      (error, value) => value?.data || null
    )
  }

  execute(file: File) {
    return this.remoteData.fromPromise(
      this.service.convertDocxToHtml(file)
    )
  }
}
